import { render, staticRenderFns } from "./ReportEditSavePrompt.vue?vue&type=template&id=4a6bf641&scoped=true"
import script from "./ReportEditSavePrompt.vue?vue&type=script&lang=js"
export * from "./ReportEditSavePrompt.vue?vue&type=script&lang=js"
import style0 from "./ReportEditSavePrompt.vue?vue&type=style&index=0&id=4a6bf641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6bf641",
  null
  
)

export default component.exports